import { React } from '@biletiniz/ui-core';
import { Layout } from '@biletiniz/ui-layout';
import { TicketCancelContainer } from '@biletiniz/web-app-containers';
import { NextSeo } from '@biletiniz/seo';
import { useRouter } from '@biletiniz/web-app-hooks';
import { LayoutHeader } from '@biletiniz/web-app-components';
import Head from 'next/head';

const TicketCancel = () => {
  const { busPnrQueryForm, router } = useRouter();
  return (
    <>
      <Layout>
        <NextSeo
          title="Otobüs Bilet İptali - Biletiniz.com | İptal Prosedürleri ve Bilgileri"
          description="Biletiniz.com'dan satın aldığınız otobüs biletini iptal etme prosedürleri ve bilgileri. İptal koşulları ve süreç hakkında detaylı bilgi alın."
          canonical={`https://biletiniz.com${router.locale !== 'tr' ? '/en' : ''
            }/bilet-iptal/otobus`}
        />
        <Head>
          <meta
            name="keywords"
            content="Otobüs Bilet İptali, Bilet İptal Prosedürleri, Otobüs İptal Koşulları, İptal Bilgileri, Bilet İptal Talebi, Biletiniz.com İptal Politikası, Bilet İade Süreci, Otobüs Seyahati İptal"
          />
        </Head>
        <LayoutHeader activeItem="buses" router={router} />
        <Layout.Container py={5}>
          <TicketCancelContainer initialValues={busPnrQueryForm} />
        </Layout.Container>
        <Layout.Footer activeItem="buses" />
      </Layout>
    </>
  );
};

export async function getStaticProps(context) {
  const { default: lngDict = {} } = await import(
    `@biletiniz/intl/locales/${context.locale}.json`
  );
  return {
    props: { lng: context.locale, lngDict },
  };
}

export default TicketCancel;
